import MuiButton from './MuiButton';
import MuiOutlinedInput from './MuiOutlinedInput';

const components = {
  MuiButton,
  MuiOutlinedInput
};

export default components;